import { GAME_TYPE_CONFIGS } from "constants/GameTypes";

export const getIsChallengeMatchGame = (gameType) => {
    return GAME_TYPE_CONFIGS[gameType].isChallenge;
};
